
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.167 4H4.056c-.46 0-.834.38-.834.85v.284H1.833c-.46 0-.833.38-.833.85v9.637c0 1.096.87 1.984 1.944 1.984h16.39c.92 0 1.666-.761 1.666-1.7V4.85c0-.47-.373-.85-.833-.85zM2.944 15.905a.28.28 0 01-.277-.284V6.834h.555v8.787a.28.28 0 01-.278.284zm8.195-.567H5.86a.421.421 0 01-.417-.425v-.284c0-.235.187-.425.417-.425h5.278c.23 0 .417.19.417.425v.284a.421.421 0 01-.417.425zm7.222 0h-5.278a.421.421 0 01-.416-.425v-.284c0-.235.186-.425.416-.425h5.278c.23 0 .417.19.417.425v.284a.421.421 0 01-.417.425zm-7.222-3.401H5.86a.421.421 0 01-.417-.426v-.283c0-.235.187-.425.417-.425h5.278c.23 0 .417.19.417.425v.283a.421.421 0 01-.417.426zm7.222 0h-5.278a.421.421 0 01-.416-.426v-.283c0-.235.186-.425.416-.425h5.278c.23 0 .417.19.417.425v.283a.421.421 0 01-.417.426zm0-3.402h-12.5a.421.421 0 01-.417-.425V6.693c0-.235.187-.425.417-.425h12.5c.23 0 .417.19.417.425V8.11a.421.421 0 01-.417.425z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_menu_jns.svg